import { render, staticRenderFns } from "./SearchShowAllOrders.vue?vue&type=template&id=0fbab22b&scoped=true"
import script from "./SearchShowAllOrders.vue?vue&type=script&lang=js"
export * from "./SearchShowAllOrders.vue?vue&type=script&lang=js"
import style0 from "./SearchShowAllOrders.vue?vue&type=style&index=0&id=0fbab22b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbab22b",
  null
  
)

export default component.exports